<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.58496 0.970703C7.36601 0.189655 8.63301 0.189655 9.41406 0.970703L15.0283 6.58496C15.8094 7.36601 15.8094 8.63301 15.0283 9.41406L9.41406 15.0283C8.63301 15.8094 7.36601 15.8094 6.58496 15.0283L0.970703 9.41406C0.189655 8.63301 0.189655 7.36601 0.970703 6.58496L6.58496 0.970703Z"
            fill="#DB3743"
        />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 9.01291V6.98633H11.5V9.01291H4.5Z" fill="white" />
    </svg>
</template>
